import { STATES } from "../../utils/helpers";

import InputUncontrolled from "../../components/InputUncontrolled";
import SelectUncontrolled from "../../components/SelectUncontrolled";

export default function AddressFields({ data, errors }) {
	return (
		<>
			<div className="two">
				<div>
					<InputUncontrolled
						type="text"
						label="Street Address"
						req={true}
						name="address1"
						value={data.address1}
						errors={errors}
						autocomplete="street-address"
					/>
				</div>
				<div>
					<InputUncontrolled
						type="text"
						label="Address 2"
						req={false}
						name="address2"
						value={data.address2}
						errors={errors}
						autocomplete="off"
					/>
				</div>
			</div>

			<div className="three">
				<div>
					<InputUncontrolled
						type="text"
						label="City"
						req={true}
						name="city"
						value={data.city}
						errors={errors}
						autocomplete="address-level2"
					/>
				</div>
				<div>
					<SelectUncontrolled
						label="State"
						req={true}
						name="st"
						value={data.st}
						data={[].concat(
							STATES.map((item) => {
								return { value: item.value, name: item.name };
							}),
						)}
						errors={errors}
						autocomplete="address-level1"
					/>
				</div>

				<div>
					<InputUncontrolled
						type="text"
						label="Zip Code"
						req={true}
						name="zip"
						value={data.zip}
						errors={errors}
						autocomplete="postal-code"
					/>
				</div>
			</div>
		</>
	);
}
